import { render, staticRenderFns } from "./costcentre-selector.vue?vue&type=template&id=48555008&"
import script from "./costcentre-selector.vue?vue&type=script&lang=ts&"
export * from "./costcentre-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports